/*
 * Created Date: Tue, 11th May 2021, 17:34:34 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2021 The Distance
 */

import React from 'react';
import { Button } from 'react-admin';
import { Link } from 'react-router-dom';
import { linkButton } from 'styles';

const LinkButton = ({
  basePath,
  name,
  to,
  icon,
  addLabel,
  noStyles = false,
  ...rest
}) => {
  const classes = linkButton();
  return (
    <Button
      className={noStyles ? classes.none : classes.root}
      component={Link}
      to={to}
      label={name}
      {...rest}
    >
      {icon}
    </Button>
  );
};

LinkButton.defaultProps = { addLabel: false };

export default LinkButton;
